import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { usePageMetadata } from "../context/PageMetadataContext";

const TermsOfService: React.FC = () => {
    const {setHeading,setTitle,setDescription} = usePageMetadata();
      useEffect(() => {
        setHeading("Terms of Service");
        setTitle("Terms of Service");
        setDescription("Read the Terms of Service for using PiScan.");
      }, [setTitle, setDescription, setHeading]);
  return (
    <div className="white-zone content-page py-5">
      <h1 className="mb-4">Terms of Service</h1>
      <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>

      <section className="mb-4">
        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>PiScan</strong> (the "Website"), accessible at <a href="https://piscan.io" className="text-primary">https://piscan.io</a>. 
          PiScan is a blockchain explorer that provides public access to blockchain transaction data, smart contract interactions, 
          and related information. By accessing or using our Website, you agree to be bound by these Terms of Service ("Terms"). 
          If you do not agree to these Terms, please do not use the Website.
        </p>
      </section>

      <section className="mb-4">
        <h2>2. Use of Services</h2>
        <p>
          PiScan provides access to blockchain data, including transaction histories, token transfers, and smart contract analytics. 
          You acknowledge and agree that:
        </p>
        <ul>
          <li>All blockchain data is publicly available and not controlled by PiScan.</li>
          <li>You are responsible for ensuring that your use of PiScan complies with applicable laws and regulations.</li>
          <li>We do not guarantee the accuracy, completeness, or reliability of blockchain data displayed on PiScan.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>3. No Financial Advice</h2>
        <p>
          PiScan provides blockchain analytics and data for informational purposes only. We do not provide investment, financial, 
          or legal advice. Any actions taken based on information from PiScan are at your own risk.
        </p>
      </section>

      <section className="mb-4">
        <h2>4. Account and API Usage</h2>
        <p>
          PiScan may offer API access to blockchain data. By using our API, you agree to:
        </p>
        <ul>
          <li>Comply with rate limits and other usage restrictions.</li>
          <li>Not use the API for malicious or unauthorized purposes.</li>
          <li>Understand that PiScan reserves the right to suspend or terminate API access at any time.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>5. Intellectual Property</h2>
        <p>
          All content on PiScan, including text, graphics, logos, and software, is owned or licensed by PiScan and protected by copyright and trademark laws. 
          You may not copy, modify, distribute, or reproduce any content from PiScan without prior written permission.
        </p>
      </section>

      <section className="mb-4">
        <h2>6. Limitation of Liability</h2>
        <p>
          PiScan is provided "as is" without warranties of any kind. We are not responsible for:
        </p>
        <ul>
          <li>Errors or inaccuracies in blockchain data.</li>
          <li>Losses or damages arising from reliance on information from PiScan.</li>
          <li>Unauthorized access to or use of our Website.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>7. Third-Party Links</h2>
        <p>
          PiScan may contain links to third-party websites. We do not endorse or assume responsibility for any content, products, or services offered by third parties.
        </p>
      </section>

      <section className="mb-4">
        <h2>8. Third-Party Content Disclaimer</h2>
        <p>
          Our website may contain advertisements or links to third-party content. We are not responsible for the accuracy, legality, or safety of any third-party material. By interacting with such content, you acknowledge that it is entirely at your own risk.
        </p>
        <p>
          PiScan does not review, endorse, or take responsibility for any products, services, or content offered through third-party advertisements. Any interactions with advertisers or third-party content providers are solely between you and that third party.
        </p>
        <p>
          If you click on third-party links or interact with third-party advertisements, you may be subject to the terms and policies of those third parties. We encourage you to review their terms and privacy policies before engaging with their content.
        </p>
      </section>

      <section className="mb-4">
        <h2>9. Modifications to Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of PiScan after changes are posted constitutes your acceptance of the revised Terms.
        </p>
      </section>

      <section className="mb-4">
        <h2>10. Termination</h2>
        <p>
          We reserve the right to suspend or terminate access to PiScan for violations of these Terms or for any other reason at our discretion.
        </p>
      </section>

      <section className="mb-4">
        <h2>11. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction]. Any disputes shall be resolved in the courts of [Your Jurisdiction].
        </p>
      </section>

      <section className="mb-4">
        <h2>12. Contact Us</h2>
        <p>
          If you have any questions regarding these Terms, please contact us at:
        </p>
        <p>Email: <a href="mailto:contact@piscan.io" className="text-primary">contact@piscan.io</a></p>
      </section>

      <hr />
      <p className="text-muted">Last Updated: {new Date().toLocaleDateString()}</p>
    </div>
  );
};

export default TermsOfService;
